/* eslint-disable max-len */
import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="88"
    height="88"
    fill="none"
    stroke="#f5f6fa"
    strokeWidth="3"
    strokeLinejoin="round"
  >
    <path d="M44 43.5a8 8 0 1 0 0-16 8 8 0 1 0 0 16z" />
    <path
      d="M50.355 30c-.098-.485-.15-.986-.15-1.5a7.5 7.5 0 1 1 7.5 7.5 7.49 7.49 0 0 1-6.001-3m-15.922 0c-1.368 1.822-3.546 3-6 3a7.5 7.5 0 1 1 7.5-7.5c0 .514-.052 1.015-.15 1.5"
      strokeLinecap="round"
    />
    <path d="M15.049 33a7 7 0 1 0 0-14 7 7 0 1 0 0 14zm59.22 0a7 7 0 1 0 0-14 7 7 0 1 0 0 14zM33.242 58.305c2.563-4.371 5.096-7.16 10.758-7.16s8.195 2.789 10.758 7.16c.93 1.586 1.357 3.786 1.536 5.835.211 2.405.316 3.607-.606 4.614s-2.288 1.007-5.02 1.007H37.332c-2.732 0-4.098 0-5.02-1.007s-.817-2.209-.606-4.614c.179-2.049.606-4.249 1.536-5.835z" />
    <g strokeLinecap="round">
      <path d="M56.41 63.556h8.219c2.732 0 4.098 0 5.02-1.007s.817-2.209.606-4.614c-.179-2.049-.606-4.249-1.536-5.835-2.563-4.371-5.096-7.16-10.758-7.16-5.238 0-7.798 2.387-10.182 6.205M31.59 63.556h-8.22c-2.732 0-4.098 0-5.02-1.007s-.817-2.209-.606-4.614c.18-2.049.606-4.249 1.537-5.835 2.563-4.371 5.096-7.16 10.758-7.16 5.238 0 7.798 2.387 10.182 6.205" />
      <path d="M23.833 46.492c-2.243-4.007-4.353-6.205-9.308-6.205s-7.17 2.556-9.413 6.563c-.743 1.328-1.119 3.124-1.298 4.857-.248 2.397-.372 3.595.552 4.62s2.301 1.025 5.054 1.025h8.209m46.538-10.86c2.243-4.007 4.353-6.205 9.308-6.205s7.17 2.556 9.413 6.563c.743 1.328 1.119 3.124 1.298 4.857.248 2.397.372 3.595-.552 4.62s-2.301 1.025-5.054 1.025h-8.209" />
    </g>
  </svg>
);
